<template>
  <modal ref='modal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('folder_show.modals.delete.title') }}</h5>
    </template>

    <template #body>
      <form @submit.prevent='deleteFolder' class="modal-fix">
        <div class='modal-body'>
          <p>{{ $t('folder_show.modals.delete.label') }}</p>
        </div>

        <div class='modal-footer'>
          <input @click.prevent='$refs.modal.close' type='submit' :value="$t('folder_show.modals.delete.cancel')" class="btn btn-outline-primary">
          <input type='submit' :value="$t('folder_show.modals.delete.submit')" class='btn btn-danger' />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        folder: {},
      }
    },
    methods: {
      open(folder) {
        this.folder = Object.assign({}, folder)
        this.$refs.modal.open()
      },
      deleteFolder() {
        this.store.destroyFolder(this.folder.id).then(() => {
          this.store.sendMetrics({name: 'remove_folder', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
          this.$refs.modal.close()
        })
      }
    }
  }
</script>
